import { mastheadStat, navCategories } from '@/mocks/home';

export default function Masthead() {
  return (
    <header className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-5 py-5 md:flex-row md:items-end md:justify-between md:gap-8 md:py-7">
          <div className="flex items-end gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary-500 text-background-50 md:h-16 md:w-16">
              <i className="ri-newspaper-line text-2xl md:text-3xl" aria-hidden="true"></i>
            </div>
            <div>
              <h1 className="font-heading text-3xl font-black leading-none tracking-tight text-foreground-950 md:text-5xl">
                黑料福利
              </h1>
              <p className="mt-2 flex items-center gap-2 text-[11px] tracking-[0.32em] text-foreground-600 md:text-xs">
                资讯聚合
                <span className="h-1 w-1 rounded-full bg-primary-500" aria-hidden="true"></span>
                专区导航
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col gap-3 md:w-auto md:items-end">
            <div className="flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2 md:w-80">
              <i className="ri-search-line text-base text-foreground-500" aria-hidden="true"></i>
              <input
                type="text"
                aria-label="站内检索"
                placeholder="检索话题、专区或关键词"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
            </div>
            <div className="flex items-center gap-4 text-xs text-foreground-600">
              <span className="flex items-center gap-1.5">
                <span className="live-dot block h-1.5 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
                今日更新 <strong className="font-bold text-foreground-900">{mastheadStat.updated}</strong> 条
              </span>
              <span className="hidden h-3 w-px bg-background-300 sm:block" aria-hidden="true"></span>
              <span className="hidden sm:inline">
                专区通道 <strong className="font-bold text-foreground-900">{mastheadStat.channels}</strong> 个
              </span>
            </div>
          </div>
        </div>

        <nav aria-label="板块导航" className="border-t-2 border-foreground-950">
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 py-2.5">
            {navCategories.map((cat) => (
              <li key={cat.id}>
                <a
                  href={`#${cat.id}`}
                  className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-foreground-800 transition-colors hover:text-primary-600"
                >
                  {cat.label}
                  <span className="text-xs text-foreground-400">{cat.count}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}